import React from 'react';
import { Hero } from '../components/home/Hero';
import { References } from '../components/home/References';
import { WhatIsDTech } from '../components/home/WhatIsDTech';
import { ProductShowcase } from '../components/home/ProductShowcase';
import { AvailabilityDelivery } from '../components/home/AvailabilityDelivery';
import { WhyDTechUnified } from '../components/home/WhyDTechUnified';
import { Applications } from '../components/home/Applications';
import { PromoPopup } from '../components/home/PromoPopup';
interface HomePageProps {
  onRequestQuote: (productId?: string) => void;
}
export function HomePage({
  onRequestQuote
}: HomePageProps) {
  return <main data-id="element-804">
      <PromoPopup onRequestQuote={() => onRequestQuote()} data-id="element-805" />
      <Hero onRequestQuote={() => onRequestQuote()} data-id="element-806" />
      <References data-id="element-807" />
      <WhatIsDTech data-id="element-808" />
      <ProductShowcase onRequestQuote={onRequestQuote} data-id="element-809" />
      <AvailabilityDelivery onRequestQuote={() => onRequestQuote()} data-id="element-810" />
      <WhyDTechUnified data-id="element-811" />
      <Applications data-id="element-812" />
    </main>;
}